import { useFeatureFlagContext } from '../providers/FeatureFlagProvider';

/**
 * Centralized hook for runtime feature flags (public).
 * Replaces scattered env checks and duplicated constants.
 * Uses FeatureFlagProvider cache — does not fetch on every render.
 */
export const useFeatureFlags = () => {
    const { flags, loading, error, isEnabled, refresh } = useFeatureFlagContext();
    return { flags, loading, error, isEnabled, refresh };
};

export default useFeatureFlags;
